<template>
  <div class="content">
    <div v-show="!loaded">
      <div class="lds-dual-ring"></div>
    </div>
    <div class="inner" v-show="loaded">
      <h1 class="title">
        <span v-if="parent_link.name">
          <router-link :to="parent_link">
            <span v-html="parent_name ? parent_name : '<em>New entry</em>'"></span> </router-link
          >&nbsp;&gt;
        </span>
        <strong v-html="name_ || '<em>New entry</em>'"></strong>
      </h1>

      <div class="actions">
        <a @click.prevent="savePage(false)" class="btn edit-save" href v-show="!listOnly">
          <i :class="'fa fa-' + (items_schema.publish_icon || 'cloud-upload')"></i>
          {{ items_schema.publish_text || "Publish" }}
        </a>
        <a @click="confirmLink(link)" :key="i" class="btn edit-save" :class="link.class" v-for="(link, i) in links">
          <i v-if="link.icon" :class="'fa fa-' + link.icon"></i>
          {{ link.text }}</a
        >
      </div>

      <schema-section
        :internal="internal"
        :key="index"
        :page="page"
        :ref="'section' + index"
        :section="section"
        :single="single"
        @add="addItem(section)"
        @delete="deleteItem(page, section, $event)"
        @editing="editSection(section, $event)"
        @reorder="reorderItems(page, section, $event)"
        @save="saveSection(page, section, $event)"
        v-for="(section, index) in visibleSections"
      />
    </div>

    <modal :show="$store.state.showCropModal" @close="closeCropModal" maxwidth="500px">
      <image-crop :internal="internal" v-if="$store.state.showCropModal"></image-crop>
    </modal>
  </div>
</template>

<script>
import datetimeutil from "date-and-time"
import api from "@/services/api"
import validate from "@/validate"
import htmlToText from "html-to-text"
import shortid from "shortid"

import SchemaSection from "@/components/SchemaSection.vue"
import ImageCrop from "@/components/ImageCrop.vue"
import Modal from "@/components/Modal.vue"

export default {
  name: "PageEdit",
  components: {
    SchemaSection,
    ImageCrop,
    Modal
  },
  data: function () {
    return {
      loaded: false,
      name_: "",

      internal: false,
      items_schema: {},
      schema: [],
      order_by: {},
      page: {},
      parent_link: {},
      parent_name: ""
    }
  },
  created() {
    api.getSchema("page." + this.$route.params.type.replace(/-/g, "")).then((response) => {
      var schema = JSON.parse(JSON.stringify(response))

      var p = []
      var shadowed_by = null
      var links = null
      if (schema.items && schema.items.shadowed_by) shadowed_by = schema.items.shadowed_by
      if (schema.items && schema.items.links) links = schema.items.links
      if (schema.items && schema.items.shadows) {
        p.push(api.getSchema(schema.items.shadows))
      }

      Promise.all(p).then((val) => {
        if (val.length) {
          schema = Object.assign(schema, JSON.parse(JSON.stringify(val[0])))
          schema.items.shadowed_by = shadowed_by
          schema.items.links = links
        }

        if (schema.items) this.items_schema = schema.items
        if (schema.items && schema.items.order_by) this.order_by = schema.items.order_by
        if (schema.items && schema.items.type && schema.items.type == "internal") this.internal = true

        api.getPage(this.$route.params.id, this.internal).then((response) => {
          this.page = response
          this.setStaticName()

          // Add blank title and url for populating on blur
          if (!this.page.hasOwnProperty("title")) this.$set(this.page, "title", "")
          if (!this.page.hasOwnProperty("url")) this.$set(this.page, "url", "")

          this.getParent()

          this.schema = schema.item

          this.$nextTick().then(() => (this.loaded = true))
        })
      })
    })
  },
  computed: {
    links: function () {
      if (!this.items_schema) return []
      if (!this.items_schema.links) return []
      return this.items_schema.links.filter((l) => {
        if (!l.condition) return true
        else return this.page[l.condition.prop] == l.condition.value
      })
    },
    visibleSections: function () {
      var sections = []
      this.schema.forEach((section) => {
        if (this.$store.getters.showOn(this.page, section.show_on, section.hide_on)) {
          if (section.name == "General Details" || section.type == "sub") sections.push(section)
          else if (!this.page.disable_navigation) sections.push(section)
        }
      })
      return sections
    },
    listOnly: function () {
      return this.visibleSections.every((sec) => sec.type == "list")
    },
    single: function () {
      return this.visibleSections.length == 1
    },
    searchField: function () {
      var fields = []
      this.schema.forEach((section) => {
        if (section.properties) {
          section.properties.forEach((prop) => {
            if (prop.searchable && section.type != "list" && this.page[prop.prop_name]) {
              var plain = htmlToText.fromString(this.page[prop.prop_name], { tables: true, wordwrap: false })

              fields.push(plain)
              fields.push(plain.replace(/[^a-zA-Z0-9\/\.\ ]/g, " "))
            }

            if (section.type == "list" && this.page[section.prop_name] && prop.searchable) {
              this.page[section.prop_name].forEach((item) => {
                if (item[prop.prop_name]) {
                  var plain = htmlToText.fromString(item[prop.prop_name], { tables: true, wordwrap: false })
                  fields.push(plain)
                  fields.push(plain.replace(/[^a-zA-Z0-9\/\.\ ]/g, " "))
                }
              })
            }

            if (
              prop.type == "list" &&
              prop.properties.filter((p) => p.searchable).length &&
              this.page[section.prop_name]
            ) {
              var items = this.page[section.prop_name].filter((i) => i[prop.prop_name] && i[prop.prop_name].length)
              var props = prop.properties.filter((p) => p.searchable)
              items.forEach((item) => {
                props.forEach((p) =>
                  item[prop.prop_name].forEach((i) => {
                    var plain = htmlToText.fromString(i[p.prop_name], { tables: true, wordwrap: false })
                    fields.push(plain)
                    fields.push(plain.replace(/[^a-zA-Z0-9\/\.\ ]/g, " "))
                  })
                )
              })
            }
          })
        }
      })
      return fields.join(" ").toLowerCase().replace(/ +/g, " ")
    }
  },
  methods: {
    confirmLink(link) {
      if (!link.confirm) {
        window.open(this.replaceTokens(link.href), "_blank")
        return
      }

      if (window.confirm(link.confirm)) window.open(this.replaceTokens(link.href), "_blank")
    },
    getParent() {
      if (this.page.ParentID) {
        api.getPage(this.page.ParentID, this.internal).then((parent) => {
          this.parent_link = {
            name: "page-edit",
            params: { id: parent.ItemID, type: parent.ItemType.split(".")[1] }
          }
          this.parent_name = parent.name
        })
      }
    },
    setStaticName() {
      if (this.items_schema.item_name_props) {
        this.name_ = ""
        this.items_schema.item_name_props.forEach((prop) => {
          if (this.page[prop.prop_name]) {
            if (this.name_) this.name_ += prop.prefix || " "
            this.name_ += this.page[prop.prop_name]
          }
        })
      } else this.name_ = this.page.name
    },
    replaceTokens(val) {
      var found = val.match(/\{\{(.*?)\}\}/g)

      found.forEach((token) => {
        var prop = token.replace(/\{/g, "")
        prop = prop.replace(/\}/g, "")

        val = val.replace(token, this.page[prop])
      })

      return encodeURI(val)
    },
    closeCropModal() {
      this.$store.commit("clearImageToCrop")
    },
    addItem(section) {
      var orderindex = 1

      if (section.order_by && section.order_by.type == "date")
        orderindex = datetimeutil.format(new Date(), "YYYY-MM-DD")
      else if (section.order_by && section.order_by.type == "date-ms")
        orderindex = Math.floor(new Date().getTime() / 1000).toString()
      else if (section.subs && section.subs.length) orderindex = section.subs.length + 1

      var initial = {}
      if (section.defaults)
        section.defaults.forEach((p) => {
          if (p.type == "date-ms") {
            // if (p.default == "today") initial[p.prop_name] = Math.floor(new Date().getTime() / 1000)
            if (p.default == "today") initial[p.prop_name] = Math.floor(new Date().getTime() / 1000).toString()
          } else initial[p.prop_name] = p.default
        })

      if (section.inherit_props)
        for (var property in section.inherit_props) {
          initial[property] = this.page[section.inherit_props[property]]
        }

      api.addSubItem(section.item_type, orderindex, this.page.ItemID, initial, this.internal).then((response) =>
        this.$router.push({
          name: "page-edit",
          params: { id: response.data }
        })
      )
    },
    editSection(section, e) {
      this.$set(section, "editing", e.editing)
      if (section.editing) {
        if (e.i == -1 && section.properties) {
          var defaults = section.properties.filter((p) => p.default)
          defaults.forEach((d) => (e.page[d.prop_name] = d.default))
        }

        // Set page property on section to object being edited
        this.$set(section, "page", JSON.parse(JSON.stringify(e.page)))

        // Use _id to track object being edited
        section.current_id = e.page._id

        // Use index to track if object is new
        section.current_i = e.i
      }

      // clear errors from properties
      for (var iprop = 0; iprop < section.properties.length; iprop++) {
        if (section.properties[iprop].error) section.properties[iprop].error = ""
      }
    },
    saveSection(parent, section, e) {
      if (section.editing) {
        var item = JSON.parse(JSON.stringify(e.newvalue))
        validate(this, item, [section], false).then((isValid) => {
          if (isValid) {
            if (section.current_i > -1) {
              // No array.find in IE
              var index = -1
              for (var i = 0; i < parent[section.prop_name].length; ++i) {
                if (parent[section.prop_name][i]._id == section.current_id) {
                  index = i
                  break
                }
              }

              // If editing existing item, overwrite object
              parent[section.prop_name][index] = item
            } else {
              // If adding new item, set array if needed, then push new item
              if (!parent[section.prop_name]) this.$set(parent, section.prop_name, [])

              // Add timestamp to new item
              item._timestamp = Date.now()

              var multi = section.properties.filter((p) => p.multi)
              if (multi.length) {
                var items = []
                var prop_name = multi[0].prop_name
                var props = JSON.parse(JSON.stringify(item[prop_name]))
                props.forEach((prop) => {
                  // Push to property
                  item[prop_name] = prop
                  item._id = shortid.generate()
                  parent[section.prop_name].push(JSON.parse(JSON.stringify(item)))
                })
              } else {
                // Push to property
                parent[section.prop_name].push(item)
              }
            }

            if (this.listOnly) {
              this.savePage(true)
            }

            // Close section
            this.editSection(section, { editing: false })
          }
        })
      }
    },
    deleteItem(parent, section, e) {
      parent[section.prop_name].splice(e.i, 1)

      if (this.listOnly) {
        this.savePage(true)
      }
    },
    reorderItems(parent, section, e) {
      parent[section.prop_name].splice(e.newIndex, 0, parent[section.prop_name].splice(e.oldIndex, 1)[0])

      if (this.listOnly) {
        this.savePage(true)
      }
    },
    savePage(silent = false) {
      this.$store.commit("clearPromises")

      var sch = this.schema
      var page = this.page
      validate(this, page, sch).then((isValid) => {
        if (isValid) {
          // If items has order by, and the order by prop is present on the page,
          // update the OrderIndex to use the value of the prop on the page
          // Otherwise, put a blank date in OrderIndex
          if (this.order_by.prop_name && page[this.order_by.prop_name]) {
            if (this.order_by.type == "date") {
              var date = datetimeutil.parse(page[this.order_by.prop_name], "DD/MM/YYYY")
              page.OrderIndex = datetimeutil.format(date, "YYYY-MM-DD")
            }
            if (this.order_by.type == "date-ms") {
              page.OrderIndex = page[this.order_by.prop_name]
            }
          } else if (this.order_by.type && this.order_by.type == "date") page.OrderIndex = "0000-00-00"
          else if (this.order_by.type && this.order_by.type == "date-ms") page.OrderIndex = "0"

          for (var isec = 0; isec < sch.length; isec++) {
            if (sch[isec].properties)
              for (var iprop = 0; iprop < sch[isec].properties.length; iprop++) {
                var prop = sch[isec].properties[iprop]
                var prop_name = prop.prop_name

                // If property is blank, remove from object
                // To satisfy dynamoDB
                // Might not need to in v2 when using aws-sdk
                if (page[prop_name] === "") delete page[prop_name]

                // Remove blank title and url on pages where it has been added
                // for onblur, but is not shown on page
                if (page["title"] === "") delete page["title"]
                if (page["url"] === "") delete page["url"]
              }
          }

          // Set active, new pages are inactive by default
          this.page.active = true

          // Set search field
          this.page._search = this.searchField
          if (!this.page._search) delete this.page._search

          if (this.page.disable_navigation) delete this.page.url

          api.putPage(this.page, this.internal, this.items_schema.shadowed_by).then(() => {
            this.setStaticName()
            this.getParent()
            if (!silent)
              this.$store.dispatch({
                type: "setSuccess",
                message: "Save successful"
              })
          })
        }
      })
    }
  }
}
</script>
